/**
 * The Regta document node language — IR v1.
 *
 * This is the contract between a block compiler (which owns all the
 * conditional business logic) and a renderer (which owns none of it). A
 * compiled document says WHAT the document says; it never records WHY the
 * application decided to say it.
 *
 * Two rules keep this stable for years rather than releases:
 *
 *  1. **Semantic, not visual.** There is no `fontSize`, no `padding`, no
 *     CSS. A node names a document construct; a theme decides how it looks.
 *     The only layout the IR carries is pagination intent (`keepTogether`,
 *     `pageBreakBefore`), which is genuinely a property of the document.
 *  2. **Boring, not domain-specific.** A node type earns its place only if
 *     it could plausibly appear in twenty different legal documents. Anything
 *     narrower — "yrkande", "förhandlingssammanträde" — is the compiler's
 *     job to express in these primitives.
 *
 * `IR_VERSION` is bumped only for a fundamental change to the language
 * (e.g. tables gaining row-span semantics). A new block, a new wording, a
 * new template is NOT an IR version bump.
 */
export const IR_SCHEMA = 'regta.document';
export const IR_VERSION = 1;
export const numberAffixes = (style) => {
    if (style === 'point')
        return { prefix: '', suffix: '.' };
    if (style === 'plain')
        return { prefix: '', suffix: '' };
    return { prefix: '§ ', suffix: '' };
};
//# sourceMappingURL=nodes.js.map